import { Decoration, DecorationSet } from '@tiptap/pm/view';
import { EditorState } from '@tiptap/pm/state';
import { ySyncPluginKey, relativePositionToAbsolutePosition } from 'y-prosemirror';

type DecorationBuilderProps = {
  state: EditorState;
  from: number;
  to: number;
  id: string;
};

export const createPreCommentHighlightDecoration = ({
  state,
  from,
  to,
  id,
}: DecorationBuilderProps) => {
  const YState = ySyncPluginKey.getState(state);

  let resolvedFrom: Record<string, any> | number | null;
  let resolvedTo: Record<string, any> | number | null;

  if (typeof from === 'number' || typeof to === 'number') {
    resolvedFrom = from;
    resolvedTo = to;
  } else {
    resolvedFrom =
      relativePositionToAbsolutePosition(YState.doc, YState.type, from, YState.binding.mapping) ??
      -1;
    resolvedTo =
      relativePositionToAbsolutePosition(YState.doc, YState.type, to, YState.binding.mapping) ?? -1;
  }

  const decoration = Decoration.inline(
    Number(resolvedFrom),
    Number(resolvedTo),
    {
      nodeName: 'span',
      class: 'pre-comment-highlight',
      'data-highlighted': id,
    },
    {
      inclusiveStart: false,
      inclusiveEnd: false,
    }
  );

  decoration.spec['data-highlighted'] = id;

  const decorationSet = DecorationSet.create(state.doc, [decoration]);

  return decorationSet || DecorationSet.empty;
};
